import { Directive, OnDestroy } from '@angular/core';
import { ReplaySubject, Observable, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export abstract class NdmsSafeSubscriber implements OnDestroy {
  private _destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  unsubscribeAll() {
    this._destroy$.next(true);
    this._destroy$.complete();
  }

  unsubscribePrev() {
    this._destroy$.next(true);
    this._destroy$.next(false);
  }

  safeSubscribe<T>(observable: Observable<any>, next: any, error?: any, complete?: any): Subscription {
    return observable.pipe(takeUntil(this._destroy$)).subscribe({ next: next, error: error, complete: complete });
  }
}
